import React from 'react';

export const IconSmallCheckLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M9.525 15.096L5.99 11.561l-1.415 1.414 3.536 3.535 1.414 1.415 1.414-1.415 8.486-8.485-1.415-1.414-8.485 8.485z"
            fill="#374050"
            fillRule="evenodd"
        />
    </svg>
);
